import React, { useEffect } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import moment from "moment-jalaali";
import {useSelector,useDispatch} from "react-redux";
import {logout} from "../../store"

const DataListUi = (props) => {
  const {
    dateList,
    selectDate,
    setSelectDate,
    selectedProduct,
    download,
    downloadLink,
    setLoading,
    standardPolygon,
    setDownloadLink
  } = props;
  const token = useSelector((state) => state.auth.Token);
  const  dispatch = useDispatch();
  useEffect(() => {
    if (selectDate) {
      setLoading(true);
      fetch(
        `http://213.233.177.17:8022/map_upload/?product=${selectedProduct.tag}&date=${selectDate}&polygon=${standardPolygon}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else {
            console.log(data);
            setDownloadLink(data);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [selectDate,dispatch,selectedProduct.tag,setDownloadLink,setLoading,standardPolygon,token]);
  return (
    <div className="date-list-container">
      <h3>تاریخ های موجود</h3>
      <ScrollContainer hideScrollbars={false} className="date-box">
        {dateList.map((item, index) => (
          <button
            className={selectDate === item ? "select-button" : null}
            key={(index ** 5).toString()}
            onClick={() =>
              setSelectDate(
                selectedProduct.tag !== "ET" ? `${item[0]}-01-01` : item
              )
            }
          >
            {selectedProduct.tag !== "ET" ? (
              <p>{moment(`${item[0]}/01/01`).format("jYYYY")}</p>
            ) : (
              <p>{moment(item[0]).format("jYYYY/jMM/jDD")}</p>
            )}
          </button>
        ))}
      </ScrollContainer>
      <div className="download-box">
        <h3>دریافت فایل</h3>
        <div className="button-container">
          {selectDate && (
            <>
              {/* <a
                    className="download-link"
                    href={"http://213.233.177.17:8022/" + downloadLink.png}
                    download="file"
                  > */}
              <button
                onClick={() =>
                  download(
                    "http://213.233.177.17:8022/" + downloadLink.png,
                    `${selectedProduct.tag}.png`
                  )
                }
              >
                .png
              </button>
              {/* </a> */}
              <a
                className="download-link"
                href={"http://213.233.177.17:8022/" + downloadLink.tif}
              >
                <button>.tiff</button>
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataListUi;
